// extracted by css-extract-rspack-plugin
var _1 = "vwIyzoCrCjw47X2k";
var _2 = "iFlQPhNU4jAtSdOq";
var _3 = "vwIyzoCrCjw47X2k";
var _4 = "iFlQPhNU4jAtSdOq";
var _5 = "FipJ_L6kB9Qp8WZN";
var _6 = "FipJ_L6kB9Qp8WZN";
var _7 = "MQOO2c1NL083X0hz";
var _8 = "kkdoC7vBo5Qomeee";
var _9 = "txnIce97JVwkWiJY";
var _a = "kkdoC7vBo5Qomeee";
var _b = "txnIce97JVwkWiJY";
var _c = "auBchvIK5gZSCLyP";
var _d = "w1EVWkHive84oBff";
var _e = "w1EVWkHive84oBff";
export { _1 as "accordion-content", _2 as "accordion-title", _3 as "accordionContent", _4 as "accordionTitle", _5 as "form-guide", _6 as "formGuide", _7 as "match", _8 as "match--domestic", _9 as "match-list", _a as "matchDomestic", _b as "matchList", _c as "placeholder", _d as "text-big", _e as "textBig" }
